document.addEventListener("alpine:init", () => {
  Alpine.store("cartToast", {
    visible: false,
    message: "",
    imageUrl: "",
    timeoutId: null,

    async showToast(productTitle, quantity, imageUrl) {
      
      const cartMessage = `${quantity} × ${productTitle}`;

      if (this.visible) {
        this.hideToast();
        setTimeout(() => {
          this.message = cartMessage;
          this.imageUrl = imageUrl;
          this.visible = true;
          this.startTimeout();
        }, 250);
      } else {
        this.message = cartMessage;
        this.imageUrl = imageUrl;
        this.visible = true;
        this.startTimeout();
      }
    },


    hideToast() {
      this.visible = false;
      clearTimeout(this.timeoutId);
    },

    startTimeout() {
      this.timeoutId = setTimeout(() => {
        this.visible = false;
      }, 4000);
    },

    async translateText(text, lang) {
      const wordList = [{ t: 1, w: text }];

      return new Promise((resolve) => {
        Weglot.translate({ words: wordList, languageTo: lang }, (data) => {
          if (data && data.length === 1) {
            resolve(data[0]);
          } else {
            console.warn("Translation failed or returned unexpected result");
            resolve(text);
          }
        });
      });
    },
  });
});


document.addEventListener("alpine:init", () => {
  Alpine.data("cartExporter", () => ({
    LOGO_URL: document.getElementById("logo").dataset.logoUrl,
    translations: {},

  async loadTranslations() {
      const lang = window?.Weglot?.getCurrentLang?.() || 'en';

      this.translations = {
        exportSku: "SKU",
        exportProductTitle: "Product title",
        exportUnitPrice: "Unit price",
        exportQuantity: "Quantity",
        exportTaxAmount: "Tax amount",
        exportLineTotal: "Line total",
        exportSubTotal: "Subtotal",
        exportTaxTotal: "Tax total",
        exportDate: "Date",
        exportNote: "Shipping and taxes will be calculated during checkout"
        
      };

      if (lang === 'en' || !window.Weglot?.translate) return;

      const keys = Object.keys(this.translations);
      const texts = keys.map(k => ({ t: 1, w: this.translations[k] }));

      await new Promise((res) => {
        Weglot.translate({ words: texts, languageTo: lang }, (data) => {
          keys.forEach((k, i) => {
            if (data[i]) {
              this.translations[k] = data[i];
            }
          });
          res();
        });
      });
    },

    async fetchCartItems() {
      try {
        const response = await fetch("/cart.js");
        const { items } = await response.json();
        return items;
      } catch (error) {
        console.error("Failed to fetch cart:", error);
        return [];
      }
    },

    formatEuro(value) {
      return new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },

    calculateTotals(items) {
      let subtotal = 0;
      const rows = items.map((item, i) => {
        const unitPrice = item.final_price / 100;
        const lineTotal = unitPrice * item.quantity;
        subtotal += lineTotal;

        return {
          index: i + 1,
          sku: item.sku || "-",
          title: item.product_title,
          unitPrice,
          quantity: item.quantity,
          lineTotal,
        };
      });
      return { rows, subtotal };
    },

    async exportCartToPdf() {
      await this.loadTranslations();

      const lang = Weglot.getCurrentLang();
      const items = await this.fetchCartItems();
      if (!items.length) return;

    
      const { jsPDF } = window.jspdf;
      if (!jsPDF) {
        console.error("jsPDF not available.");
        return;
      }

      const doc = new jsPDF();
      const logoBlob = await fetch(this.LOGO_URL).then((r) => r.blob());
      const logoData = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.readAsDataURL(logoBlob);
      });

      doc.setFontSize(16);
      doc.addImage(logoData, "PNG", 14, 10, 40, 15);
      doc.setFontSize(10);
      doc.text(
        `${this.translations.exportDate}: ${new Date().toLocaleString(
          "de-DE"
        )}`,
        14,
        30
      );

      const { rows, subtotal } = this.calculateTotals(items);
      const tableBody = rows.map((row) => [
        row.sku,
        row.title,
        this.formatEuro(row.unitPrice),
        row.quantity,
        this.formatEuro(row.lineTotal),
      ]);

      const headers = [
        [
          this.translations.exportSku,
          this.translations.exportProductTitle,
          this.translations.exportUnitPrice,
          this.translations.exportQuantity,
          this.translations.exportLineTotal,
        ],
      ];

      doc.autoTable({
        startY: 35,
        head: headers,
        body: tableBody,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: {
          fillColor: [33, 114, 58],
          textColor: 255,
          fontSize: 9,
        },
        columnStyles: {
          0: { cellWidth: 25 },
          1: { cellWidth: 60 },
          2: { cellWidth: 40 },
          3: { cellWidth: 30 },
          4: { cellWidth: 30 },
        },
      });

      const finalY = doc.lastAutoTable.finalY || 50;
      doc.setFontSize(9);
      doc.text(`${this.translations.exportSubTotal}:`, 140, finalY + 10);
      doc.text(this.formatEuro(subtotal), 183, finalY + 10, { align: "right" });

      doc.text(`${this.translations.exportNote}`, 15, finalY + 30);

      const now = new Date();
      const date = now.toISOString().slice(0, 10);
      const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
      doc.save(`4phones-cart-${date}_${time}.pdf`);
    },

    async exportCartToExcel() {
      await this.loadTranslations();
      const items = await this.fetchCartItems();
      if (!items.length) return;

      const { rows, subtotal } = this.calculateTotals(items);

      const excelRows = [
        [
          "#",
          this.translations.exportSku,
          this.translations.exportProductTitle,
          this.translations.exportUnitPrice,
          this.translations.exportQuantity,
          this.translations.exportLineTotal,
        ],
        ...rows.map((row) => [
          row.index,
          row.sku,
          row.title,
          this.formatEuro(row.unitPrice),
          row.quantity,
          this.formatEuro(row.lineTotal),
        ]),
        [
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        [
          "",
          "",
          "",
          "",
          this.translations.exportSubTotal,
          this.formatEuro(subtotal),
        ],
        [
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        [
          "",
          "",
          "",
          "",
          "",
          "",
        ],
        [
          "",
          "",
          "",
          "",
          "",
          "",
        ],
      ];

      const ws = XLSX.utils.aoa_to_sheet(excelRows);
      ws["!cols"] = [
        { wch: 5 },
        { wch: 15 },
        { wch: 40 },
        { wch: 15 },
        { wch: 15 },
        { wch: 20 },
      ];

      ws['A' + excelRows.length] = {
        t: 's',
        v: this.translations.exportNote,
        s: {
          alignment: {
            horizontal: "center",
            vertical: "center"
          },
          font: { italic: true }
        }
      };

      const noteRowIndex = excelRows.length - 1;

      ws['!merges'] = [
        ...(ws['!merges'] || []),
        {
          s: { r: noteRowIndex, c: 0 },
          e: { r: noteRowIndex, c: 5 }, 
        }
      ];

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Cart");

      const now = new Date();
      const date = now.toISOString().slice(0, 10);
      const time = now.toTimeString().slice(0, 8).replace(/:/g, '-');
      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      

      saveAs(
        new Blob([wbout], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
        `4phones-cart-${date}_${time}.xlsx`
      );
    },
  }));
});



